import * as React from 'react';

import { useToast as useChakraToast } from '@chakra-ui/react';

export const useToast = () => {
	const toast = useChakraToast();

	const showErrorToast = React.useCallback(
		(options: { title?: React.ReactNode; message: React.ReactNode }) => {
			toast({
				title: options.title || 'Es ist ein Fehler aufgetreten.',
				description: options.message,
				status: 'error',
				duration: 9000,
				isClosable: true,
			});
		},
		[toast],
	);

	const showSuccessToast = React.useCallback(
		(options: { title: React.ReactNode; message: React.ReactNode }) => {
			toast({
				title: options.title,
				description: options.message,
				status: 'success',
				duration: 12000,
				isClosable: true,
			});
		},
		[toast],
	);

	return {
		showSuccessToast,
		showErrorToast,
	};
};
